<template>
    <div class="official_web">
        <Header/>
        <router-view :key="key"/>
        <Footer :type="type"/>
    </div>
</template>
<script>
import Header from '@/components/views/header'
import Footer from '@/components/views/footer'
export default {
    components: {
     Header,
     Footer,
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      type:1

    }
  },
  mounted(){
    this.type= this.$route.params.id||1;
  },
  computed: {
  key() {
      //解决同一组件路由跳转，数据不刷新问题
      return this.$route.name !== undefined? this.$route.name +new Date(): this.$route +new Date()
  }
},
watch: {
    $route(to, from){
      if(to.path!='/large'){
        console.log('路由变化');
        this.type=1
      }
     
    },
    },
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/index.vue